import { createApp } from 'vue'
import App from './App.vue'
// 全屏滚动 vue-fullpage.js
import router from './router'
import store from './store'
import ElementPlus from 'element-plus' //全局引入
import 'element-plus/dist/index.css'
import './assets/scss/reset.scss'
// import 'fullpage.js/vendors/scrolloverflow';
import 'fullpage.js';
// 引入swiper的样式
import 'swiper/css/swiper.css'
import VueScrollTo from 'vue-scrollto'
import VueFullpage from 'vue-fullpage.js'


createApp(App).use(store).use(ElementPlus).use(VueFullpage).use(VueScrollTo).use(router).mount('#app')
